import { render } from "./LoadingView.vue?vue&type=template&id=34480a4c"
const script = {}

import "./LoadingView.vue?vue&type=style&index=0&id=34480a4c&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__